import {
    CLEAR_BACKGROUND_MESSAGES,
    SET_FAILURE_BACKGROUND_MESSAGES,
    SET_PROCESSING_BACKGROUND_MESSAGES,
    SET_SUCCESS_BACKGROUND_MESSAGES
} from './BackgroundMessages.actions';
import backgroundUtils from './../BackgroundMessageUtils';

import {merge} from 'lodash';

function backgroundMessages(state = {}, action) {

    switch (action.type) {

        case SET_PROCESSING_BACKGROUND_MESSAGES:
            if(!action.payload || !action.payload.type) {
                return state;
            }

            return merge({}, state, {
                title: action.payload.title,
                message: action.payload.message,
                messageParameters: action.payload.messageParameters,
                icon: "la-Restore",
                type: action.payload.type,
                isVisible: true,
                shrink: true,
                close: false
            });


        case SET_SUCCESS_BACKGROUND_MESSAGES:
            if(!action.payload || !action.payload.type) {
                return state;
            }

            return Object.assign({}, state, {
                title: action.payload.title,
                message: action.payload.message,
                messageParameters: action.payload.messageParameters,
                icon: "check-mark-svg",
                link: action.payload.link,
                type: action.payload.type,
                isVisible: action.payload.isVisible ? action.payload.isVisible : state.isVisible,
                shrink: false,
                close: true
            });


        case SET_FAILURE_BACKGROUND_MESSAGES:
            if(!action.payload || !action.payload.type) {
                return state;
            }

            return merge({}, state, {
                title: action.payload.title,
                message: action.payload.message,
                messageParameters: action.payload.messageParameters,
                icon: "la-Error",
                type: action.payload.type,
                isVisible: true,
                shrink: false,
                close: true
            });

        case CLEAR_BACKGROUND_MESSAGES:
            return merge({}, state, backgroundUtils.getInitialBackgroundMessagesState());

        default:
            return state;

    }
}

export default backgroundMessages;


// WEBPACK FOOTER //
// ./src/scripts/reusable/BackgroundMessage/redux/BackgroundMessages.reducers.js